module.exports = __webpack_public_path__ + "0c04e847d0f76b0611d3e6fc122b27d4.svg";